import { Component, Input, EventEmitter, Output } from '@angular/core';
import { MutatingInputComponent } from '../../joi-input/mutating-input.component';

@Component({
    selector: 'mobile-login-input',
    template: `
<mutating-input [placeholder]="placeholder" [prop]="prop" [object]="object" [error]="error" (textChange)="changed.emit()"></mutating-input>
<div class="label">{{ label }}</div>

`,
    styleUrls: ['./mobile-login-input.scss'],
    standalone: true,
    imports: [MutatingInputComponent]
})
export class MobileLoginInputComponent<T, K extends keyof T>{
  @Input() label: string
  @Input() placeholder: string
  @Input() error: string = ''
  @Input() object: T
  @Input() prop: K
  @Output() changed: EventEmitter<void> = new EventEmitter()
}

